<div [ngClass]="theme.getThemeClass()" class="divReportViewConfig reports-view col-12">
  <h4 class="filter-title">{{ 'filters' | translate }}</h4>
  <nav class="filter-bar col-12">
    <div class="device-filter col-12">
      <div class="form-group">
        <div class="force-column">
          <label class="form-label" id="deciveStats">{{ 'deviceStatistics' | translate }}</label>
          <select [disabled]="true" [(ngModel)]="statistic" class="form-control ng-select">
            @for (option of statisticOptions; track option.value) {
              <option [ngValue]="option.value">
                {{ option.label | translate }}
              </option>
            }
          </select>
        </div>
      </div>

      <div class="device-filter">
        <div class="form-group">
          <div class="force-column">
            <label class="form-label">{{ 'startingDate' | translate }}</label>
            <input [(ngModel)]="startDate" class="form-control" type="date" />
          </div>
        </div>

        <div class="form-group">
          <div class="force-column">
            <label class="form-label">{{ 'endDate' | translate }}</label>
            <input [(ngModel)]="endDate" class="form-control" type="date" />
          </div>
        </div>
      </div>

      <div class="toggle-stack">
        <div class="toggle-box">
          <label class="devices-toggle">{{ 'allDevices' | translate }}</label>
          <label class="markets-toggle">{{ 'allMarkets' | translate }}</label>
        </div>

        <div class="filter-toggle">
          <div class="custom-control custom-switch cs-container">
            <label class="switch">
              <input type="checkbox" [ngModel]="allThings" name="devices" (change)="onChangeAllThings($event)" />
              <span class="slider round"></span>
            </label>
          </div>
          <div class="custom-control custom-switch cs-container">
            <label class="switch">
              <input
                type="checkbox"
                [ngModel]="allMarkets"
                name="markets"
                (change)="onChangeAllMarkets($event)"
                [disabled]="true"
              />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
    </div>

    @if (!allThings) {
    <div class="form-group col-12">
      <nav colspan="12" id="search-component" class="input-group searchDiv">
        <div class="sort-by-group">
          <label class="sort-by-group-label" for="deviceClient">{{ 'devicecreateLabelClient' | translate }}</label>
          <select
            class="form-control"
            id="deviceClient"
            name="deviceClient"
            [(ngModel)]="selectedClient"
            (ngModelChange)="onClientChange()"
          >
            <option [ngValue]="''" selected>
              {{ 'devicecreateSelectClient' | translate }}
            </option>
            @for (client of thingClient; track client.client_id) {
              <option [ngValue]="client.client_id">
                {{ client.legal_name }}
              </option>
            }
          </select>
        </div>
        <div class="sort-by-group">
          <label class="sort-by-group-label">{{ 'deviceGroup' | translate }}</label>
          <select
            [(ngModel)]="filterThingGroup"
            class="form-control sort-by-group-select"
            name="thingGroup"
            (ngModelChange)="onGroupChange()"
          >
            @for (option of thingGroupOptions; track option.value) {
              <option [ngValue]="option.value">
                {{ option.label | translate }}
              </option>
            }
          </select>
        </div>

        @if (selectedClient && selectedClient.trim()) {
          <div class="sort-by-group">
            <label class="sort-by-group-label">{{ 'deviceSubGroup' | translate }}</label>
            <select
              [(ngModel)]="filterThingSubGroup"
              class="form-control sort-by-group-select"
              name="thingSubGroup"
              (ngModelChange)="onSubGroupChange()"
            >
              @for (subGroup of clientSubGroups || []; track subGroup.sub_groupID) {
                <option [ngValue]="subGroup.sub_groupID">
                  {{ subGroup.sub_group_name }}
                </option>
              }
            </select>
          </div>
        }
        <!-- <button class="resetFilters btn btn-dropdown" (click)="resetDeviceFilters()">
          {{ 'resetFilters' | translate }}
        </button> -->
      </nav>

      <div class="force-column">
        <label class="form-label multi-select-label">{{ 'devices' | translate }} ({{ things.length }})</label>
        <div class="multi-select-container" style="position: relative;">
        <app-custom-multi-select
          [(ngModel)]="selectedThings"
          class="form-control ng-select"
          [multiple]="true"
          [options]="things"
          bindLabel="id"
          bindValue="id"
        ></app-custom-multi-select>
        </div>

      </div>
    </div>
    }

    @if (!allMarkets) {
      <div class="form-group">
        <div class="force-column">
          <label class="form-label">{{ 'marketSegments' | translate }}</label>
          <app-custom-multi-select
            [disabled]="true"
            [(ngModel)]="selectedMarkets"
            [multiple]="true"
            class="form-control ng-select"
            [options]="marketSegmentOptions"
            bindLabel="label"
            bindValue="value"
            [translateLabels]="true"
          ></app-custom-multi-select>
        </div>
      </div>
    }
  </nav>

  <div class="btn-holder col-12">
    <button
      [ngClass]="theme.getThemeClass()"
      class="form-control btn btn-primary btn-bloc btn-second"
      (click)="compileReport()"
      [disabled]="pdf.generatingPDF"
    >
      @if (!pdf.generatingPDF) {
        <span>
          {{ 'printPDF' | translate }}
        </span>
      }
      @if (pdf.generatingPDF) {
        <div class="spinner-border spinner-position spinner-button" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      }
    </button>

    <button
      [ngClass]="theme.getThemeClass()"
      class="form-control btn btn-primary btn-bloc btn-second"
      (click)="exportCSVReports()"
      [disabled]="generatingCSV"
    >
      @if (!generatingCSV) {
        <span>
          {{ 'exportCSV' | translate }}
        </span>
      }
      @if (generatingCSV) {
        <div class="spinner-border spinner-position spinner-button" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      }
    </button>
  </div>
</div>



<div
  id="canvas-holder"
  style="
    width: 600px;
    height: 600px;
    position: absolute;
    top: -9999px;
    left: -9999px;
    pointer-events: none;
    overflow: hidden;
  "
>
  <canvas id="tonnageCanvas" #tonnageCanvas width="600" height="400"></canvas>
  <canvas id="usageCanvas" #usageCanvas width="400" height="400"></canvas>
  <canvas id="marketCanvas" #marketCanvas width="400" height="400"></canvas>
  <canvas id="countCanvas" #countCanvas width="600" height="400"></canvas>
  <canvas id="marketTonnageCanvas" #marketTonnageCanvas width="600" height="400"></canvas>
  <canvas id="usageTonnageCanvas" #usageTonnageCanvas width="600" height="400"></canvas>
  <canvas id="subgroupTonnageCanvas" #subgroupTonnageCanvas width="600" height="400"></canvas>
</div>
